import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2979c620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-100 rounded-xl p-3 overflow-x-auto w-full" }
const _hoisted_2 = { class: "w-full min-w-max border-collapse" }
const _hoisted_3 = { class: "text-neutral50 text-sm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "Médico", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "CRM", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "Data", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "Horário", -1))
const _hoisted_8 = { class: "font-bold text-center whitespace-nowrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "text-neutral50"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "8",
    x2: "12.01",
    y2: "8"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Esse campo não é equivalente às"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" posições do Minha Escala e não será"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" considerado para a conciliação ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "Entrada", -1))
const _hoisted_12 = {
  key: 0,
  class: "font-bold text-center whitespace-nowrap"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-center whitespace-nowrap" }, "Saída", -1))
const _hoisted_14 = {
  key: 1,
  class: "font-bold text-center whitespace-nowrap"
}
const _hoisted_15 = { class: "py-1 pr-1 text-center whitespace-nowrap" }
const _hoisted_16 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_17 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_18 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_19 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_20 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_21 = {
  key: 0,
  class: "py-1 px-1 text-center align-middle"
}
const _hoisted_22 = { class: "flex justify-center items-center h-full" }
const _hoisted_23 = { class: "py-1 px-1 text-center whitespace-nowrap" }
const _hoisted_24 = {
  key: 1,
  class: "py-1 pl-1 text-center align-middle"
}
const _hoisted_25 = { class: "flex justify-center items-center h-full" }

import { PropType } from 'vue'

export interface DsAttendanceInfoRow {
  doctorName: string
  crm: string | number
  date: string
  time: string
  station: string
  entryTime: string
  entrySignature: boolean
  exitTime: string
  exitSignature: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceInfoSheetsCard',
  props: {
  items: {
    type: Array as PropType<DsAttendanceInfoRow[]>,
    default: () => [],
    required: true
  },
  hideSignatureColumns: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("th", _hoisted_8, [
            _createVNode(_component_v_tooltip, { location: "top" }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("div", _mergeProps(props, { class: "flex items-center justify-center gap-1.5 cursor-help transition-opacity hover:opacity-80" }), [
                  _hoisted_9,
                  _createTextVNode(" Posto ")
                ], 16)
              ]),
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _hoisted_11,
          (!__props.hideSignatureColumns)
            ? (_openBlock(), _createElementBlock("th", _hoisted_12, " Ass. e Carimbo "))
            : _createCommentVNode("", true),
          _hoisted_13,
          (!__props.hideSignatureColumns)
            ? (_openBlock(), _createElementBlock("th", _hoisted_14, " Ass. e Carimbo "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: "text-neutral50 text-sm"
          }, [
            _createElementVNode("td", _hoisted_15, _toDisplayString(item.doctorName), 1),
            _createElementVNode("td", _hoisted_16, _toDisplayString(item.crm), 1),
            _createElementVNode("td", _hoisted_17, _toDisplayString(item.date), 1),
            _createElementVNode("td", _hoisted_18, _toDisplayString(item.time), 1),
            _createElementVNode("td", _hoisted_19, _toDisplayString(item.station), 1),
            _createElementVNode("td", _hoisted_20, _toDisplayString(item.entryTime), 1),
            (!__props.hideSignatureColumns)
              ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_v_checkbox, {
                      "model-value": item.entrySignature,
                      density: "compact",
                      "hide-details": "",
                      readonly: "",
                      color: "#BCBCCD",
                      class: "flex-none m-0 p-0"
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_23, _toDisplayString(item.exitTime), 1),
            (!__props.hideSignatureColumns)
              ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_checkbox, {
                      "model-value": item.exitSignature,
                      density: "compact",
                      "hide-details": "",
                      readonly: "",
                      color: "#BCBCCD",
                      class: "flex-none m-0 p-0"
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})